import { Box, Flex } from '@chakra-ui/react'
import capitalize from 'lodash/capitalize'
import type { FC } from 'react'
import { HiSelector } from 'react-icons/hi'

import { Avatar } from '@app/components/ui/avatar'
import profileImage from '@app/utils/profileImage'
import { type Organization as OrganizationType, type User as UserType } from '@graphql/types'

type Organization = Pick<OrganizationType, 'name'>
type User = Pick<UserType, 'name' | 'email' | 'role' | 'abilities'> & { organization?: Organization }
export interface UserButtonProps {
  user: User
}

const UserButton: FC<UserButtonProps> = ({ user }) => (
  <Flex
    align="center"
    display="flex"
    m={2}
    px="3"
    py="2"
    fontSize="sm"
    bg="bg.muted"
    borderWidth={1}
    borderRadius="base"
    _active={{ bg: 'bg.subtle' }}
    _focus={{ shadow: 'tertiary' }}
    userSelect="none"
    cursor="pointer"
    transition="all 0.2s"
    outline="0"
    rounded="lg"
  >
    <Flex flex="1" gap="3">
      <Avatar w="8" h="8" name={user.name} size="sm" src={profileImage(user.email)} />
      <Box w="100%" textAlign="start">
        <Box fontWeight="semibold" lineClamp={1}>
          {user.name}
        </Box>
        <Box color="muted" fontSize="xs" wordBreak="break-all" lineClamp={1}>
          {user.email}
        </Box>
        {user.organization && (
          <Box color="muted" fontSize="xs" wordBreak="break-all" lineClamp={1}>
            {user.organization.name} {capitalize(user.role)}
          </Box>
        )}
      </Box>
    </Flex>
    <Flex color="accent" fontSize="lg">
      <HiSelector />
    </Flex>
  </Flex>
)

export default UserButton
